import { PILLAR_COLORS } from '../../constants/pillarColors';
import type { PillarType } from '../../constants/pillarColors';

interface PillarIconProps {
  pillar: PillarType;
  size?: number;
  color?: string;
}

function BuildingIcon({ size, color }: { size: number; color: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      {/* Roof */}
      <path d="M8 2L15 7H1L8 2Z" fill={color} />
      {/* Walls */}
      <rect x="2" y="7" width="12" height="7" fill={color} opacity="0.7" />
      {/* Door */}
      <rect x="6" y="10" width="4" height="4" fill={color} opacity="0.4" />
    </svg>
  );
}

function SwordsIcon({ size, color }: { size: number; color: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      {/* Sword 1: top-left to bottom-right */}
      <line x1="2" y1="2" x2="14" y2="14" stroke={color} strokeWidth="2" strokeLinecap="round" />
      {/* Guard 1 */}
      <line x1="4" y1="6" x2="7" y2="3" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
      {/* Sword 2: top-right to bottom-left */}
      <line x1="14" y1="2" x2="2" y2="14" stroke={color} strokeWidth="2" strokeLinecap="round" />
      {/* Guard 2 */}
      <line x1="12" y1="6" x2="9" y2="3" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  );
}

function FlaskIcon({ size, color }: { size: number; color: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      {/* Flask body */}
      <path
        d="M6 1H10V6L14 13C14 14.1 13.1 15 12 15H4C2.9 15 2 14.1 2 13L6 6V1Z"
        fill={color}
        opacity="0.7"
      />
      {/* Flask top rim */}
      <rect x="5" y="1" width="6" height="1.5" rx="0.5" fill={color} />
      {/* Bubble */}
      <circle cx="9" cy="11" r="1.5" fill={color} opacity="0.5" />
    </svg>
  );
}

export function PillarIcon({ pillar, size = 14, color }: PillarIconProps) {
  const iconColor = color ?? PILLAR_COLORS[pillar].primary;

  if (pillar === 'economy') {
    return <BuildingIcon size={size} color={iconColor} />;
  }
  if (pillar === 'military') {
    return <SwordsIcon size={size} color={iconColor} />;
  }
  return <FlaskIcon size={size} color={iconColor} />;
}
